import {IntermediatePart} from "../../intermediatePart";
import Walls from "../../parts/walls";
import {getCurrentRoomType} from "../../../../appLayout";
import {LOOK_ROOM_TYPES} from "../../constants";

export default class ShowerWall extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_wall';
    this.partName = 'Shower Wall';
    this.translateId = "visualizer.bathroom.shower.shower_wall";
    this.homePageTitle = 'Interior Shower Walls';
    this.isStoneFeature = true;
    this.canUseWizard = true;
    this.layerPriority = 2;
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const showerParent = this.getParent();
    const showerSize = showerParent ? showerParent.showerSize() : null;
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      })
    }
    // if (wallParent && wallParent.splitWallType) {
    //   conditions.push({
    //     propName: "SplitWallType",
    //     propValue: wallParent.splitWallType
    //   })
    // }
    const wallParent = showerParent.layout.parts[Walls.id];
    if (getCurrentRoomType(showerParent.layout) === LOOK_ROOM_TYPES.as && wallParent && wallParent.splitWall) {
      conditions.push({
        propName: "SplitWallType",
        propValue: wallParent.getSplitWallType()
      })
    }
    return conditions
  }

}
